module.exports = __webpack_public_path__ + "img/page1.e1b3f33b.png";